import { render, staticRenderFns } from "./BannerList.vue?vue&type=template&id=70f74eb1&"
import script from "./BannerList.vue?vue&type=script&lang=ts&"
export * from "./BannerList.vue?vue&type=script&lang=ts&"
import style0 from "./BannerList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports